import React, { useState, useRef, useEffect } from 'react';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions, Tab, Tooltip, TableRow, Typography, Card, CardContent, Modal, Grid, Stack, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material'
import { Box } from '@mui/system';
import { DataGrid, GridToolbarQuickFilter, GridActionsCellItem } from '@mui/x-data-grid';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { mappedGrowersData, monthlyPlanningData } from "./_mock/user";
import { CustomButton } from '../../common/custom-button/customButton';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { FETCH_MAPPINGS, GET_APPROVED_STAKEHOLDERS, GET_SHORTLISTED_STAKEHOLDERS, GET_STAKEHOLDER_BY_TYPE, LIST_OF_IS_LLE_GROWER, SAVE_SHORTLISTED_STAKEHOLDERS } from '../../common/URLs';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { async } from 'q';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { DEMAND_CONSTANTS, PROD } from '../../common/constants';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { FetchIcon, ShortlistIcon, ViewIcon } from '../../common/icons';
import apiClient from '../../axios';

export const MonthlyPlanning = () => {
  const { t } = useTranslation();
  let arrData = [];
  const uuid = localStorage.getItem('uuid');
  const [tabValue, setTabValue] = React.useState('1');
  const [open, setOpen] = React.useState(false);
  const [stakeholderCommonData, setStakeholderCommonData] = React.useState([]);
  const [mappedGrowerData, setMappedGrowerData] = React.useState([]);
  const [selectedLleIsData, setSelectedLleIsData] = React.useState([]);
  const [viewBtnClickedStakeholderList, setviewBtnClickedStakeholderList] = React.useState();
  const [shortlistedGrowers, setShortlistedGrowers] = React.useState([]);
  const [selectedGrowers, setSelectedGrowers] = React.useState([]);

  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [selectedFinancialYearErr, setSelectedFinancialYearErr] = useState();
  const [selectedShortlistedFinancialYear, setSelectedShortlistedFinancialYear] = useState();

  const [isShortlistBtnDisabled, setIsShortlistBtnDisabled] = React.useState(true);
  const [shortlistedStakeholdersList, setShortlistedStakeholdersList] = React.useState([]);
  const [shortlistedGrowerFromApi, setShortlistedGrowerFromApi] = React.useState([]);
  const [selectionModel, setSelectionModel] = useState([]);

  const [fetchMappingStakeholdersList, setFetchMappingStakeholdersList] = React.useState([]);
  const [isFetchMappingdisabled, setIsFetchMappingDisabled] = React.useState(true);

  const [planningMonth, setPlanningMonth] = useState('Jan');
  const [shortlistedPlanningMonth, setShortlistedPlanningMonth] = useState('Jan');
  const [pageSize, setPageSize] = React.useState(10);
  const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const [shortlistDialog, setShortlistDialog] = useState(false);
  const handleShortlistDialogOpen = () => setShortlistDialog(true);
  const handleShortlistDialogClose = () => setShortlistDialog(false);
  const [fetchMappingsDialog, setFetchMappingsDialog] = useState(false);
  const handleFetchMappingsDialogOpen = () => setFetchMappingsDialog(true);
  const handleFetchMappingsDialogClose = () => setFetchMappingsDialog(false);

  const columns = [
    {
      field: 'name',
      headerName: t('preReg.name'),
      width: 190
    },
    {
      field: 'urn',
      headerName: 'Urn',
      width: 200,
      sortComparator: (a, b) => lastFiveDigitsComparator(a, b)
    },
    {
      field: 'stakeHolderType',
      headerName: 'Type',
      width: 110,
    },
    {
      field: 'age',
      headerName: 'Location',
      width: 110,
      valueGetter: (params) => {
        if (params.row.lleMasters) {
          return params.row.lleMasters[0]?.address
        } else return '-'

      }
    },
    {
      field: 'shortlist',
      headerName: 'Shortlist Growers',
      type: 'action',
      width: 150,
      renderCell: (params) => viewButton(params)
    },

  ];
  const shortlistedStakeholderCoumns = [
    {
      field: 'stakeholderUrn',
      headerName: 'Urn',
      width: 200,
    },
    {
      field: 'stakeholderType',
      headerName: 'Type',
      width: 110,
    },
    {
      field: 'shortlist',
      headerName: 'Shortlist',
      type: 'action',
      width: 110,
      renderCell: (params) => viewShortlistedButton(params)
    },
  ];
  const viewButton = (params) => {
    return (
      <Tooltip title="View">
        <IconButton disabled={!(selectedLleIsData.some((item) => item.urnNumber === params.row.urn))} color="primary"
          onClick={(e) => handleClickOpen(e, params.row.urn, params.row.stakeHolderType)}><ViewIcon /></IconButton>
      </Tooltip>
    )
  }
  const viewShortlistedButton = (params) => {
    return (
      <Tooltip title="View">
        <IconButton color="primary" onClick={(e) => handleShortlistedClickOpen(e, params.row.stakeholderUrn, params.row.stakeholderType)}><ViewIcon /></IconButton>
      </Tooltip>
    )
  }

  const growerMappedColumns = [
    {
      field: 'growerUrnNumber',
      headerName: 'Grower Urn',
      width: 190
    },
    {
      field: 'revenueCircle',
      headerName: 'Revenue Circle',
      width: 190
    },
    {
      field: 'name',
      headerName: t('preReg.name'),
      width: 190
    },
    {
      field: 'mobile',
      headerName: 'Mobile',
      width: 190
    },
  ]
  const shortlistedGrowerColumns = [
    {
      field: 'growers',
      headerName: 'Grower Urn',
      width: 190
    },
  ]

  useEffect(() => {
    getStakeholderByTypeApi();
  }, []);

  const QuickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
          float: 'right'
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    );
  }

  const handleClickOpen = (e, urn, type) => {
    e.preventDefault();
    setOpen(true);
    setSelectionModel(selectedGrowers?.filter(i => i.stakeholderURN === urn)[0]?.growerList)
    const data =
      [{
        "urnNumber": urn,
        "type": type
      }]
    setviewBtnClickedStakeholderList(data);
    getListOfLleGrower(data);
  };

  const handleShortlistedClickOpen = (e, urn, type) => {
    e.preventDefault();
    setOpen(true);
    let filteredArray = shortlistedStakeholdersList?.filter(item => item.stakeholderUrn === urn);
    let data = filteredArray[0].growers.map((c, index) => {
      return {
        "id": index,
        "growers": c
      }
    })
    setShortlistedGrowerFromApi(data);
  };

  const handleClose = (newValue) => {
    setOpen(false);
  };

  const handleModalShortlistBtn = (e) => {
    e.preventDefault();
    let result = selectedGrowers?.filter(o1 => viewBtnClickedStakeholderList.some(o2 => o1.stakeholderURN === o2.urnNumber));
    let result1 = selectedGrowers.some(o1 => viewBtnClickedStakeholderList.some(o2 => o1.stakeholderURN === o2.urnNumber));
    let dataModified = mappedGrowerData.filter((item) => {
      return shortlistedGrowers.some((temp) => temp === item.growerUrnNumber)
    })

    if (result1 === false) {
      let modifiedMapped = viewBtnClickedStakeholderList.map((item) => {
        return {
          "stakeholderType": item.type,
          "stakeholderURN": item.urnNumber,
          "growerList": shortlistedGrowers
        }
      })
      arrData.push(...modifiedMapped)
    } else if (result1 === true) {
      result.map((o) => {
        o.growerList = shortlistedGrowers
      })
    }
    setSelectedGrowers([...selectedGrowers, ...arrData])
    handleClose();

  }
  const onGrowerSelectionCallback = (value) => {
    setSelectionModel(value);
    setShortlistedGrowers(value);
  }

  const onSelectionModelChangeCallback = (value) => {
    let filteredArray = stakeholderCommonData?.filter(function (itm) {
      return value.indexOf(itm.urn) > -1;
    });

    let dataForApi = filteredArray.map((item) => {
      return {
        urnNumber: item.urn,
        type: item.stakeHolderType,
      }
    });
    setSelectedLleIsData(dataForApi)
  };

  const dialogSection = () => {
    return (
      <Dialog onClose={handleClose} open={open} maxWidth='md' fullWidth={true}>
        <DialogTitle> Shortlist Stakeholder </DialogTitle>
        <DialogContent>
          <Box sx={{ height: 400, width: '100%' }}>
            <DataGrid
              rows={mappedGrowerData}
              getRowId={(row) => row?.growerUrnNumber}
              columns={growerMappedColumns}
              onSelectionModelChange={(e) => onGrowerSelectionCallback(e)}
              selectionModel={selectionModel}
              checkboxSelection
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pageSize={pageSize}
              onPageSizeChange={(newPage) => setPageSize(newPage)}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <CustomButton
            style={{ marginTop: 5, float: 'right', marginBottom: 5 }}
            onClick={(e) => handleModalShortlistBtn(e)}
            startIcon={<ShortlistIcon />}
            title="Shortlist">Shortlist
          </CustomButton>
        </DialogActions>
      </Dialog>

    )
  }

  const handlePlanningMonthChnage = (event) => {
    setPlanningMonth(event.target.value);
    getShortlistedStakeholdersShortlistingApi(selectedFinancialYear, event.target.value);

  };
  const handleShortlistedPlanningMonthChnage = (event) => {
    setShortlistedPlanningMonth(event.target.value);
    getShortlistedStakeholdersApi(selectedShortlistedFinancialYear, event.target.value)

  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    setSelectedFinancialYearErr('');
    setIsShortlistBtnDisabled(false);
    getShortlistedStakeholdersShortlistingApi(dataToBePassed, planningMonth);

  }
  const getSelectedValueShortlisted = (dataToBePassed) => {
    setSelectedShortlistedFinancialYear(dataToBePassed);
    getShortlistedStakeholdersApi(dataToBePassed, planningMonth);
    setIsFetchMappingDisabled(false);

  }

  // -----------------API Calls-------------------

  const getStakeholderByTypeApi = async () => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'lle'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const temp = response.data.stakeHolders?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'LLE'
          return tempData
        })
        getStakeholderByTypeISApi(temp);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getStakeholderByTypeISApi = async (lleApiData) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'Interim Storage Operator'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const temp = response.data.stakeHolders?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'IS'
          return tempData
        })
        let mergedData = [...temp, ...lleApiData]
        setStakeholderCommonData(mergedData);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getListOfLleGrower = (data) => {
    loaderService.showLoader();
    apiClient.post(LIST_OF_IS_LLE_GROWER,
      { "listOfIsOrLleReqst": data },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let apiData = (response.data[0]?.mapped_growers ? response.data[0]?.mapped_growers : [])
        let growerData = apiData.map((item) => { return item?.growers })
        let modifiedData = growerData.map((grData) => {
          return {
            "revenueCircle": grData[0].revenueCircle,
            "growerUrnNumber": grData[0].regStakeholderMaster?.urn,
            "name": grData[0].regStakeholderMaster?.name,
            "mobile": grData[0].regStakeholderMaster?.mobileNo,
          }
        })
        setMappedGrowerData(modifiedData)
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onConfirmShortlist = () => {
    handleShortlistDialogClose();
    loaderService.showLoader();
    let data = {
      "financialYear": selectedFinancialYear,
      "month": planningMonth,
      "stakheholderLst": selectedGrowers
    }
    apiClient.post(SAVE_SHORTLISTED_STAKEHOLDERS,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        setSelectedGrowers([]);
        handleTabChange(null, "2");
        getShortlistedStakeholdersApi();
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const saveShortlistedStakeholdersApi = (e) => {
    if (selectedFinancialYear && !(selectedFinancialYear === 'select')) {
      handleShortlistDialogOpen();
    } else setSelectedFinancialYearErr('Please select financial year')
  }

  const getShortlistedStakeholdersApi = async (year, month) => {
    loaderService.showLoader();
    let data = {
      "financialYear": year,
      "month": month,
    }
    await apiClient.post(GET_SHORTLISTED_STAKEHOLDERS,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let data = response.data?.stakeholdersLst?.map((item) => {
          return item
        })
        setShortlistedStakeholdersList(data);

        let mappingData = response.data?.stakeholdersLst?.map((item) => {
          return {
            "urnNumber": item.stakeholderUrn,
            "type": item.stakeholderType,
            "growerUrns": item.growers
          }
        })
        setFetchMappingStakeholdersList(mappingData);

        let selectedGrowersData = response.data?.stakeholdersLst?.map((item) => {
          return {
            "stakeholderURN": item.stakeholderUrn,
            "stakeholderType": item.stakeholderType,
            "growerList": item.growers
          }
        })
        // setSelectedGrowers(selectedGrowersData ? selectedGrowersData : [])
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  const getShortlistedStakeholdersShortlistingApi = async (year, month) => {
    loaderService.showLoader();
    let data = {
      "financialYear": year,
      "month": month,
    }
    await apiClient.post(GET_SHORTLISTED_STAKEHOLDERS,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let selectedGrowersData = response.data?.stakeholdersLst?.map((item) => {
          return {
            "stakeholderURN": item.stakeholderUrn,
            "stakeholderType": item.stakeholderType,
            "growerList": item.growers
          }
        })
        setSelectedGrowers(selectedGrowersData ? selectedGrowersData : [])
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onConfirmFetchMappings = () => {
    handleFetchMappingsDialogClose();
    loaderService.showLoader();
    let data = {
      "financialYear": selectedShortlistedFinancialYear,
      "month": planningMonth,
      "listOfIsOrLleReqst": {
        "listOfIsOrLleReqst": fetchMappingStakeholdersList
      }
    }
    apiClient.post(FETCH_MAPPINGS + `?userId=${uuid}`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (response.data.isSuccess === true) toast.success(response.data.message);
        else toast.error(response.data.message);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const fetchMappingsApi = () => {
    if (fetchMappingStakeholdersList?.length === 0) toast.info(DEMAND_CONSTANTS.NoDataUpdated)
    else {
      handleFetchMappingsDialogOpen();
    }
  }


  return (
    <TabContext value={tabValue}>
      {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM02</p>}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
          <Tab label="Shortlisting" value="1" />
          <Tab label="Shortlisted" value="2" />
        </TabList>
      </Box>
      <TabPanel value="1">
        <Card>
          <CardContent>
            <Stack direction='row' spacing={1} style={{ marginBottom: 5 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={3}>
                  <FinancialYearDropdown selectedValue={getSelectedValue} helperText={selectedFinancialYearErr} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FormControl sx={{ width: 200 }} size="small">
                    <InputLabel >Planning Month</InputLabel>
                    <Select
                      value={tabValue === '1' ? planningMonth : shortlistedPlanningMonth}
                      label="Planning Month"
                      onChange={tabValue === '1' ? handlePlanningMonthChnage : handleShortlistedPlanningMonthChnage}
                    >
                      {monthArray.map((item) =>
                        <MenuItem key={item} value={item}>{item}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <CustomButton
                    style={{ marginTop: 5, float: 'right', marginBottom: 5 }}
                    title="Shortlist"
                    startIcon={<ShortlistIcon />}
                    disabled={isShortlistBtnDisabled}
                    onClick={(e) => saveShortlistedStakeholdersApi(e)}
                  />
                </Grid>
              </Grid>
            </Stack>
            <Box sx={{ height: 400, width: '100%' }}>
              <DataGrid
                getRowId={(row) => row?.urn}
                rows={stakeholderCommonData}
                columns={columns}
                checkboxSelection
                components={{ Toolbar: QuickSearchToolbar }}
                onSelectionModelChange={(e) => onSelectionModelChangeCallback(e)}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
              />
            </Box>
            {dialogSection()}
          </CardContent>
        </Card>
      </TabPanel>
      {/* Shortlisted stakeholder */}
      <TabPanel value="2">
        <Card>
          <CardContent>
            <Stack direction='row' spacing={1} style={{ marginBottom: 5 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={3}>
                  <FinancialYearDropdown selectedValue={getSelectedValueShortlisted} />
                </Grid>
                <Grid item xs={12} lg={9}>
                  <FormControl sx={{ width: 200 }} size="small">
                    <InputLabel >Planning Month</InputLabel>
                    <Select
                      value={tabValue === '1' ? planningMonth : shortlistedPlanningMonth}
                      label="Planning Month"
                      onChange={tabValue === '1' ? handlePlanningMonthChnage : handleShortlistedPlanningMonthChnage}
                    >
                      {monthArray.map((item) =>
                        <MenuItem key={item} value={item}>{item}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  <CustomButton style={{ float: 'right' }} disabled={isFetchMappingdisabled}
                    onClick={() => fetchMappingsApi()} title="Fetch Mappings" startIcon={<FetchIcon />} />
                </Grid>
              </Grid>
            </Stack>
            <Box sx={{ height: 400, width: '100%' }}>
              <DataGrid
                rows={shortlistedStakeholdersList}
                columns={shortlistedStakeholderCoumns}
                getRowId={(row) => row?.stakeholderUrn}
                disableSelectionOnClick
                hideFooter
                hideFooterPagination
                experimentalFeatures={{ newEditingApi: true }}
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
              />
            </Box>
            <Dialog onClose={handleClose} open={open} maxWidth='md' fullWidth={true}>
              <DialogTitle> Shortlisted Stakeholders </DialogTitle>
              <DialogContent>
                <Box sx={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={shortlistedGrowerFromApi}
                    getRowId={(row) => row?.id}
                    columns={shortlistedGrowerColumns}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                  />
                </Box>
              </DialogContent>
            </Dialog>
          </CardContent>
        </Card>
      </TabPanel>
      <ConfirmationPopover onOpen={shortlistDialog} onConfirm={onConfirmShortlist} onClose={handleShortlistDialogClose} action="Shortlist" />
      <ConfirmationPopover onOpen={fetchMappingsDialog} onConfirm={onConfirmFetchMappings} onClose={handleFetchMappingsDialogClose} action="Fetch Mappings" />
    </TabContext>
  )
}